// extracted by css-extract-rspack-plugin
export default {"Box":"Controls-module__Box__yPS4QLP","IconButton":"Controls-module__IconButton__nnusB0l"};